/*eslint-disable */

import axios from 'axios';
import {
  bus
} from '@/main';
import root from '@/_helpers/roots';

let userAgreementURL = root.userAgreementUrl.link;

var $ = window.jQuery = require('jquery');

export default {
  name: 'task-user-agreement-popup',
  components: {},
  props: [],
  data () {
    return {
        userId:''
    }
  },
  computed: {

  },
  mounted () {
   this.userId = localStorage.getItem('LoginedUserID')
  },
  methods: {
    closeAcknowModal(){
      return new Promise((resolve, reject) => {
        axios.post(userAgreementURL, {user:  this.userId}).then((response) => {   
          localStorage.setItem('userAgreementState', 'accepted');
          bus.$emit('userAgreementStateBus', 'accepted');
          $('body').removeClass('user_agreement_popup')
          resolve(response);
        }).catch(err => {
          reject(err);
      })
    });
    }
  }
}


